module.exports = __webpack_public_path__ + "static/media/crash_3.d2e3daa1.mp3";